import axios from "axios";
import store from '../store/index'
import NotificationHandler from "./NotificationHandler";
import { enumUtil } from "./Enum";
const ServerRequestProtected = (endpoint, method, payload, signal) => {
    const API_URL = process.env.REACT_APP_API + endpoint
    let token = store.getState();
    token = token.Login.token
    const isGetRequest = method.toLowerCase() === "get";
    // let parentID = store.getState();
    // payload['ParentID'] = parentID.PracticeIDReducer
    const authorizationTokenHeader = token
        ? {
            Authorization: `Bearer ${token}`,
        }
        : {}
    const axiosConfigation = {
        method,
        url: API_URL,
        // data: payload,
        ...(isGetRequest
            ? { params: payload }
            : { data: payload }),
        headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Max-Age': '6000',
            'Access-Control-Allow-Headers': '*',

            ...(endpoint == 'Login/Login' ? {} : { ...authorizationTokenHeader }),
        },
        signal
    }

    return new Promise((resolve, reject) => {
        axios(axiosConfigation)
            .then((res) => {
                resolve(res.data)
            })
            .catch((error) => {
                if (error) {
                    if (error?.response) {
                        // let error = { response: {  data: "",}  }
                        if (error?.response?.status === 500) {
                            error.response.data = "Some unexpected error occurred. Please contact Star Healthcare support team";
                            reject(error);
                        } else if (error?.response?.status === 401) {
                            const data = window.location.href.split('/').slice(0, -2).join("/");
                            setTimeout(() => {
                                window.location.replace(data);
                            }, 0)
                            // error.response.data = "Token Expired!, Please login";
                            // reject(error);
                        }
                        else {
                            reject(error);
                        }
                    } else if (error.message && (error.message === 'Request failed with status code 401' || error.message === "Network Error") && (error.config.url === "https://starhealthcare.theeasyedi.com/Login/FindUserInfo" || error.config.url === "https://starhealthcare.theeasyedi.com/General/FillDropdowns" || error.config.url === "https://portal.theeasyedi.com/General/FillDropdowns" || error.config.url === "https://portal.theeasyedi.com/Login/FindUserInfo")) {
                        const data = window.location.href.split('/').slice(0, -2).join("/");
                        setTimeout(() => {
                            window.location.replace(data);
                        }, 0)
                        // error.response.data = "Token Expired!, Please login";
                        // reject(error);
                    } else {
                        reject(error);
                    }
                }

            })
    })
}

const ServerRequestProtectedOCR = (endpoint, method, payload, signal) => {
    const API_URL = process.env.REACT_APP_API_OCR + endpoint
    let token = store.getState();
    token = token.Login.token
    // let parentID = store.getState();
    // payload['ParentID'] = parentID.PracticeIDReducer
    const authorizationTokenHeader = token
        ? {
            Authorization: `Bearer ${token}`,
        }
        : {}
    const axiosConfigation = {
        method,
        url: API_URL,
        data: payload,
        headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Max-Age': '6000',
            'Access-Control-Allow-Headers': '*',

            ...(endpoint == 'Login/Login' ? {} : { ...authorizationTokenHeader }),
        },
        signal
    }

    return new Promise((resolve, reject) => {
        axios(axiosConfigation)
            .then((res) => {
                resolve(res.data)
            })
            .catch((error) => {
                if (error) {
                    if (error?.response) {
                        // let error = { response: {  data: "",}  }
                        if (error?.response?.status === 500) {
                            error.response.data = "Some unexpected error occurred. Please contact Star Healthcare support team";
                            reject(error);
                        } else if (error?.response?.status === 401) {
                            const data = window.location.href.split('/').slice(0, -2).join("/");
                            setTimeout(() => {
                                window.location.replace(data);
                            }, 0)
                            // error.response.data = "Token Expired!, Please login";
                            // reject(error);
                        }
                        else {
                            reject(error);
                        }
                    } else if (error.message && (error.message === 'Request failed with status code 401' || error.message === "Network Error") && (error.config.url === "https://starhealthcare.theeasyedi.com/Login/FindUserInfo" || error.config.url === "https://starhealthcare.theeasyedi.com/General/FillDropdowns" || error.config.url === "https://portal.theeasyedi.com/General/FillDropdowns" || error.config.url === "https://portal.theeasyedi.com/Login/FindUserInfo")) {
                        const data = window.location.href.split('/').slice(0, -2).join("/");
                        setTimeout(() => {
                            window.location.replace(data);
                        }, 0)
                        // error.response.data = "Token Expired!, Please login";
                        // reject(error);
                    } else {
                        reject(error);
                    }
                }

            })
    })
}

const ServerRequestPublic = (endpoint, method, payload, type, signal) => {
    const API_URL2 = process.env.REACT_APP_API + endpoint
    let token = store.getState();
    token = token.Login.token
    const isGetRequest = method.toLowerCase() === "get";
    const authorizationTokenHeader = token
        ? {
            Authorization: `Bearer ${token}`,
        }
        : {}
    let axiosConfigation;
    // axios obj
    if (type === "Download") {
        axiosConfigation = {
            method,
            url: API_URL2,
            // data: payload,
            ...(isGetRequest
                ? { params: payload }
                : { data: payload }),
            responseType: 'blob',
            headers: {
                Accept: '*/*',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Access-Control-Max-Age': '6000',
                'Access-Control-Allow-Headers': '*',

                ...authorizationTokenHeader,
            },
            signal
        }
    } else if (type === "Upload") {
        axiosConfigation = {
            method,
            url: API_URL2,
            data: payload,
            headers: {
                Accept: '*/*',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Max-Age': '6000',
                'Access-Control-Allow-Headers': '*',
                "Content-Type": "multipart/form-data",
                ...authorizationTokenHeader,
            },
            signal
        }
    } else {
        axiosConfigation = {
            method,
            url: endpoint,
            data: payload,
            headers: {
                Accept: '*/*',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Access-Control-Max-Age': '6000',
                'Access-Control-Allow-Headers': '*',

                ...authorizationTokenHeader,
            },
            signal
        }
    }
    return new Promise((resolve, reject) => {
        axios(axiosConfigation)
            .then((res) => {
                resolve(res.data)
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    const data = window.location.href.split('/').slice(0, -2).join("/");
                    setTimeout(() => {
                        window.location.replace(data);
                    }, 0)
                    // error.response.data = 'Token Expired!, Please login';
                    // reject(error);
                }
                else if (error.response && error.response.status === 500) {
                    let error = {
                        response: {
                            data: "Some unexpected error occurred. Please contact Star Healthcare support team",
                        }
                    }
                    reject(error);
                } else {
                    reject(error);
                }
            })
    })
}
const ServerRequestClearnigHouse = (endpoint, method, payload) => {
    const API_URL = process.env.REACT_APP_API_CH + endpoint
    const axiosConfigation = {
        method,
        url: API_URL,
        data: payload,
        headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Max-Age': '6000',
            'Access-Control-Allow-Headers': '*',
        },
    }

    return new Promise((resolve, reject) => {
        axios(axiosConfigation)
            .then((res) => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
const GetZipCode = async (zipCode) => {
    if (zipCode.length === 5 || zipCode.length === 9) {
        try {
            const apiUrl = `https://api.zippopotam.us/us/${zipCode}`;
            const response = await axios.get(apiUrl);
            const place = response.data.places[0];
            const stateDisplay = `${place['state abbreviation']} - ${place.state}`;
            const main = {
                State: stateDisplay,
                City: place['place name']
            };
            const save = {
                State: place['state abbreviation'],
                City: place['place name']
            };
            const data = {
                main,
                save
            };
            return data;
        } catch (error) {
            throw error;
        }
    } else {
        return null;
    }
};
const ServerRequestProtectedWithoutToken = (endpoint, method, payload, signal) => {
    const API_URL = process.env.REACT_APP_API + endpoint;
    const axiosConfigation = {
        method,
        url: API_URL,
        data: payload,
        headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Max-Age': '6000',
            'Access-Control-Allow-Headers': '*',
        },
        signal
    }

    return new Promise((resolve, reject) => {
        axios(axiosConfigation)
            .then((res) => {
                resolve(res.data)
            })
            .catch((error) => {
                if (error) {
                    if (error?.response) {
                        // let error = { response: {  data: "",}  }
                        if (error?.response?.status === 500) {
                            error.response.data = "Some unexpected error occurred. Please contact Star Healthcare support team";
                            reject(error);
                        } else if (error?.response?.status === 401) {
                            // const data = window.location.href.split('/').slice(0, -2).join("/");
                            // setTimeout(() => {
                            //     window.location.replace(data);
                            // }, 0)
                            // error.response.data = "Token Expired!, Please login";
                            reject(error);
                        }
                        else {
                            reject(error);
                        }
                    } else if (error.message && (error.message === 'Request failed with status code 401' || error.message === "Network Error") && (error.config.url === "https://starhealthcare.theeasyedi.com/Login/FindUserInfo" || error.config.url === "https://starhealthcare.theeasyedi.com/General/FillDropdowns" || error.config.url === "https://portal.theeasyedi.com/General/FillDropdowns" || error.config.url === "https://portal.theeasyedi.com/Login/FindUserInfo")) {
                        // const data = window.location.href.split('/').slice(0, -2).join("/");
                        // setTimeout(() => {
                        //     window.location.replace(data);
                        // }, 0)
                        // error.response.data = "Token Expired!, Please login";
                        reject(error);
                    } else {
                        reject(error);
                    }
                }

            })
    })
}

export { ServerRequestProtected, ServerRequestProtectedOCR, ServerRequestPublic, ServerRequestClearnigHouse, GetZipCode, ServerRequestProtectedWithoutToken }